// extracted by mini-css-extract-plugin
module.exports = {"container":"PropertyContainer_container__1i6Bz"};